/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 1.75C4.5482 1.75 1.75 4.5482 1.75 8S4.5482 14.25 8 14.25s6.25-2.7982 6.25-6.25a.75.75 0 0 1 1.5 0c0 4.2802-3.4698 7.75-7.75 7.75S.25 12.2802.25 8 3.7198.25 8 .25a.75.75 0 0 1 0 1.5Zm7.5303.2197a.75.75 0 0 1 0 1.0606L8 10.5607 4.9697 7.5303a.75.75 0 0 1 1.0606-1.0606L8 8.4393l6.4697-6.4696a.75.75 0 0 1 1.0606 0Z"
      clipRule="evenodd"
    />
  </>,
  'Completion'
);
